<template>
  <div>
    <b-jumbotron header="Sign in using Steam" lead="slotlist.info uses Steam OpenID authentication. This allows you to use your existing Steam account to log into our site." v-if="!working">
      <p class="text-justify">
        The site will not be able to read or store your Steam login credentials or perform any action regarding your Steam account.
        <br> We will only receive your SteamID as well as some other public information such as your username.
        <br> The information provided by Steam will be used to create a unique user in our backend for you, allowing you to use all features on
        <router-link to="/">slotlist.info</router-link>.
        <br> More information regarding the privacy policy of this site can be found
        <router-link to="/privacy">here</router-link>.
      </p>
      <p v-if="loginRedirectUrl" class="lead text-center">
        <a :href="loginRedirectUrl">
          <img src="https://steamcommunity-a.akamaihd.net/public/images/signinthroughsteam/sits_01.png" alt="Sign in through Steam" title="Yes, this login banner looks atrocious, unfortunately Valve forces us to use it >.< Anyways, click to sign in through Steam">
        </a>
      </p>
    </b-jumbotron>
    <div class="row text-center">
      <div class="col">
        <h4>Frequently Asked Questions regarding the Steam login</h4>
        <p>taken from the FAQ on our
          <router-link :to="{name: 'home'}">Home</router-link> page
        </p>
      </div>
    </div>
    <br>
    <div class="row text-justify">
      <div class="col-6">
        <h5>How does the login work?</h5>
        <p>
          We are utilising a login service provided by Steam, called
          <em>Steam OpenID</em> or
          <em>Steam Single Sign On</em>. You can find more information about this service
          <a href="https://steamcommunity.com/dev">here</a>.<br>When you click the
          <em>Sign in through Steam</em> button, you will be redirected to a Steam community page where you will be asked to log in to your Steam account. Please note that we have no access at all to this page and do not receive your Steam credentials. The whole login process is handled securely by Steam on the
          <code>steamcommunity.com</code> domain.
          <strong>You will never have to enter your Steam credentials on our website or any other non-Steam service.</strong><br>Once you have successfully completed your login, Steam will redirect you back to our website and provide us with information required to identify you as a user of our service.<br>The data provided by Steam's login service is limited to your SteamID as well as your nickname, both of which are also publicly visible to everyone on Steam.
        </p>
        <h5>I am still sceptical or confused...</h5>
        <p>
          We would be happy to talk to you, explaining our service in more detail and trying to clear up any confusion as best as we can - just contact us via any method mentioned on our
          <router-link :to="{name: 'about'}">About</router-link> page. Whilst we obviously would like to have you as a user of our service, we can also understand scepticism and value any sort of feedback highly.
        </p>
      </div>
      <div class="col-6">
        <h5>Can you access my Steam account after I log in to your website?</h5>
        <p>
          <strong>No, absolutely not.</strong> As previously mentioned, we do not handle any login at all, but use a service provided by Steam to all developers. All authentication is handled by Steam itself - we only receive an "assurance" you actually are who you claim to be.
          <strong>The information we receive does not grant us any access to your Steam account, Steam library or any credentials associated.</strong>
        </p>
        <h5>What information do you store about me?</h5>
        <p>
          When you log in for the first time, our backend creates a new user in our database, storing the SteamID provided by Steam's login service as well as your (public) Steam nickname at that point. You can change your nickname on this website at any point by going to your
          <router-link :to="{name: 'account'}">Account</router-link> page while logged in. Please note that changing your Steam nickname will not update your nickname on
          <router-link :to="{name: 'home'}">slotlist.info</router-link> since we do not query Steam for your nickname after the initial login anymore. Beside your SteamID and nickname, the stored user information contains a unique user ID that is randomly generated by our backend and used to uniquely identify your user throughout the app.<br>When you register for a mission slot, a database entry containing the slot ID, your user ID and the optional comment - if provided - is created.<br>If you would like to receive a dump of all information currently stored about you, please contact us via any method mentioned on the
          <router-link :to="{name: 'about'}">About</router-link> page and we will be happy to provide you with any data we have.<br>More information regarding the privacy policy of this website can be found
          <router-link :to="{name: 'privacy'}">here</router-link>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    loginRedirectUrl() {
      return this.$store.getters.loginRedirectUrl
    },
    working() {
      return this.$store.getters.working
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.en.vue?efa76fe0